import React from 'react';
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/components/ui/popover';
/* import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/components/ui/select'; */
import { Calendar } from '@/components/ui/calendar';
import { Button } from '@/components/ui/button';
import {
	addMonths,
	addYears,
	format,
	getMonth,
	/* getYear, */
	parseISO,
	setMonth,
	/* setYear, */
} from 'date-fns';
import { Typography } from '../typography';
import { Icon } from '../icon';
import Icons from '@/const/icons';
import { DateRange } from 'react-day-picker';
import Image from 'next/image';

/* import { data } from 'cypress/types/jquery'; */
import clsx from 'clsx';

interface Props {
	dateFrom?: string;
	dateTo?: string;
	buttonContent?: string | JSX.Element;
	clearAll?: () => void;
	setValue: (value?: { from: string; to: string }) => void;
	title?: string;
	buttonCustom?: boolean;
	endYearCustom?: number;
	startYearCustom?: number;
	classNameTrigger?: string;
	sideOffset?: number;
	hasButtonApply?: boolean;
	yearOrder?: 'asc' | 'desc';
	disabled?: boolean;
}

export const DatePicker: React.FC<Props> = ({
	buttonContent,
	setValue,
	clearAll,
	dateFrom,
	dateTo,
	title,
	buttonCustom,
	sideOffset = -12,
	hasButtonApply = true,
	/* endYearCustom, */
	/* startYearCustom, */
	classNameTrigger,
	/* yearOrder = 'desc', */
	disabled,
}) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const [date, setDate] = React.useState<DateRange | undefined>();
	/* 	const [isMonthOpen, setIsMonthOpen] = React.useState(false);
	const [isYearOpen, setIsYearOpen] = React.useState(false); */

	const [monthSelected, setMonthSelected] = React.useState<Date>();

	/* const startYear = startYearCustom || getYear(new Date()) - 100;
	const endYear = endYearCustom || getYear(new Date()); */

	//TODO Daniel Refactor this code in the future
	React.useEffect(() => {
		if (!isOpen) return;
		/* setIsMonthOpen(false);
		setIsYearOpen(false); */

		if (dateFrom && dateTo) {
			setTimeout(() => {
				setDate({
					from: parseISO(dateFrom),
					to: parseISO(dateTo),
				});
				const date = parseISO(dateFrom);
				const monthIndex = getMonth(date);
				const monthName = months[monthIndex];
				const newMonthIndex = months.indexOf(monthName);
				const newDate = setMonth(date, newMonthIndex);
				setMonthSelected(newDate);
			}, 300);
		}
	}, [isOpen]);

	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	/* const years = Array.from({ length: endYear - startYear + 1 }, (_, i) =>
		yearOrder === 'desc' ? endYear - i : startYear + i
	); */

	/* 	const handleMonthChange = (month: string) => {
		const currentYear = monthSelected
			? getYear(monthSelected)
			: getYear(new Date());
		const newDate = setMonth(date?.from || new Date(), months.indexOf(month));
		const dateWithCorrectYear = setYear(newDate, currentYear);
		setMonthSelected(dateWithCorrectYear);
	};

	const handleYearChange = (year: string) => {
		const newDate = setYear(monthSelected || new Date(), parseInt(year));
		setMonthSelected(newDate);
	}; */

	const handleSelect = (date: DateRange | undefined) => {
		setDate(date);
		if (date?.from && date.to && !hasButtonApply) {
			applyChanges(date);
		}
		/* if (date?.from && date.to) {
			const dateFrom = new Date(date.from);
			const dateTo = new Date(date.to);

			const formattedDateFrom = format(dateFrom, 'yyyy-MM-dd');
			const formattedDateTo = format(dateTo, 'yyyy-MM-dd');

			setValue({
				from: formattedDateFrom,
				to: formattedDateTo,
			});
		} */
	};

	const clear = () => {
		setDate(undefined);
		setValue(undefined);
		const date = new Date();
		const monthIndex = getMonth(date);
		const monthName = months[monthIndex];
		const newMonthIndex = months.indexOf(monthName);

		const newDate = setMonth(new Date(), newMonthIndex);
		setMonthSelected(newDate);
		if (clearAll) clearAll();
	};
	const handleArrowMonthChange = (direction: 'back' | 'next') => {
		const newDate =
			direction === 'back'
				? addMonths(monthSelected ?? new Date(), -1)
				: addMonths(monthSelected ?? new Date(), 1);
		setMonthSelected(newDate);
	};

	const handleArrowYearChange = (direction: 'back' | 'next') => {
		const newDate =
			direction === 'back'
				? addYears(monthSelected ?? new Date(), -1)
				: addYears(monthSelected ?? new Date(), 1);
		setMonthSelected(newDate);
	};
	const applyChanges = (date: DateRange | undefined) => {
		if (date?.from && date?.to) {
			const formattedDateFrom = format(new Date(date.from), 'yyyy-MM-dd');
			const formattedDateTo = format(new Date(date.to), 'yyyy-MM-dd');
			setValue({
				from: formattedDateFrom,
				to: formattedDateTo,
			});
		}
	};
	return (
		<Popover open={isOpen}>
			<PopoverTrigger
				className={clsx('disabled:cursor-not-allowed', classNameTrigger)}
				disabled={disabled}
			>
				{buttonCustom ? (
					<div
						className="p-0 relative"
						onClick={() => setIsOpen((prev) => !prev)}
					>
						{buttonContent}
					</div>
				) : (
					<Button
						variant={'ghost'}
						className="p-0 relative"
						onClick={() => setIsOpen((prev) => !prev)}
					>
						{buttonContent}
					</Button>
				)}
			</PopoverTrigger>

			{/* //TODO receive align and sideoffset on props */}
			<PopoverContent
				className="w-auto p-0 border-0 rounded-[32px] shadow-shadow2 max-w-[320px] pt-3 mb-10"
				align="start"
				sideOffset={sideOffset}
				onPointerDownOutside={() => setIsOpen(false)}
			>
				{title && (
					<div className="px-6 pt-2 pb-4">
						<Typography type="semibold-16">{title}</Typography>
					</div>
				)}
				<div className="flex justify-between max-w-[272px] gap-[16px] mx-auto px-2">
					<div className="flex flex-col gap-2 justify-between w-full">
						<div className="flex items-center  justify-between">
							<Button
								variant="ghost"
								className="p-0"
								onClick={() => handleArrowMonthChange('back')}
							>
								<Image
									src={Icons.arrowOutlineLeft}
									width={20}
									height={20}
									alt="arrow-icon"
									unoptimized
								/>
							</Button>

							<Typography type="semibold-14" className="text-purple-150">
								{format(monthSelected ?? new Date(), 'MMMM')}
							</Typography>
							<Button
								variant="ghost"
								className="p-0"
								onClick={() => handleArrowMonthChange('next')}
							>
								<Image
									src={Icons.arrowOutlineRight}
									width={20}
									height={20}
									alt="arrow-icon"
									unoptimized
								/>
							</Button>
						</div>
					</div>
					<div className="flex items-center justify-between w-full gap-2">
						<Button
							variant="ghost"
							className="p-0"
							onClick={() => handleArrowYearChange('back')}
						>
							<Image
								src={Icons.arrowOutlineLeft}
								width={20}
								height={20}
								alt="arrow-icon"
								unoptimized
							/>
						</Button>

						<Typography type="semibold-14" className="text-purple-150">
							{format(monthSelected ?? new Date(), 'yyyy')}
						</Typography>
						<Button
							variant="ghost"
							className="p-0"
							onClick={() => handleArrowYearChange('next')}
						>
							<Image
								src={Icons.arrowOutlineRight}
								width={20}
								height={20}
								alt="arrow-icon"
								unoptimized
							/>
						</Button>
					</div>
				</div>
				<Calendar
					mode="range"
					selected={date}
					onSelect={handleSelect}
					className="px-6"
					classNames={{
						caption: 'hidden',
						nav_button: 'hidden',
						table: '!mt-0 ',
						cell: 'w-16 text-center',
						head_cell:
							'w-16 text-center text-sm font-normal uppercase text-[#6E6A73]',
						day_selected: 'rounded-none text-white',
						day_range_start: '!bg-purple-150',
						day_range_end: '!bg-purple-150',
						/* day_today: 'rounded-none ', */
					}}
					initialFocus
					month={monthSelected}
				/>

				<div className="flex justify-between items-center pl-3 pr-4 pb-5">
					{clearAll && (
						<Button
							variant={'ghost'}
							className="font-normal flex items-center gap-2 px-2 h-12 "
							onClick={clear}
						>
							<Icon src={Icons.broom} className="!w-6 !h-6" />
							Clear All
						</Button>
					)}
					{hasButtonApply && (
						<Button
							variant={'ghost'}
							disabled={!date?.from || !date?.to}
							className=" px-6 h-8 flex rounded-[100px] items-center text-base font-semibold border text-[#8039DF] border-[#8039DF] disabled:text-[#B18EE0] disabled:border-[#B18EE0]"
							onClick={() => applyChanges(date)}
						>
							Apply
						</Button>
					)}
				</div>
			</PopoverContent>
		</Popover>
	);
};
